










































































































































import Vue from 'vue'
import {
  PropertyType,
  BuildingInformation,
  Locality,
  UnitInformation,
  SearchValuations,
} from '@/components/valuation/'
import { ValuationNavigationPill } from '@/components/partials/'
import { menuLinks } from '@/router/'
import RouteLink from '@/interfaces/app/RouteLink'
import ValuationData, {
  ValuationStepData,
} from '@/interfaces/valuation/ValuationData'
import ValuationStepValidator from '@/interfaces/valuation/ValuationStepValidator'
import ValuationService from '@/services/ValuationService'
import { ValuationStepName } from '@/interfaces/valuation/ValuationStep'
import { Message, MessageType } from '@/interfaces/app/Message'

export default Vue.extend({
  name: 'valuation',
  components: {
    SearchValuations,
    PropertyType,
    BuildingInformation,
    Locality,
    UnitInformation,
    ValuationNavigationPill,
  },
  created() {
    this.goToStep(this.currentStepUrl)
    if (this.$route.params.id) {
      this.$store.dispatch(
        'valuationProcess/recreateValuationFromValuationID',
        this.$route.params.id
      )
    }
  },
  data() {
    return {
      ValuationStepName,
    }
  },
  computed: {
    currentStepUrl(): string {
      return this.$route.params.stepName || ValuationStepName.Property
    },
    valuation(): ValuationData {
      return this.$store.getters['valuationProcess/valuationData']
    },
    validator(): ValuationStepValidator {
      return this.valuation.currentStep.validator
    },
    progress(): number {
      return 25 * this.valuation.steps.filter(s => s.validator.isValid).length
    },
    links(): RouteLink[] {
      const valuationLinks = menuLinks.find(l => l.name === this.$options.name)
      return valuationLinks!.childRoutes || []
    },
  },
  methods: {
    validateStepData(): boolean {
      const messages = this.validator.validate(this.valuation.currentStep.data)
      this.$store.dispatch('app/addTempMessages', { messages })

      return this.validator.isValid
    },
    goToStep(stepName: string): void {
      this.$store.dispatch('valuationProcess/goToStep', stepName)
    },
    nextStep(): void {
      if (this.validateStepData()) {
        const nextStepUrl = ValuationService.getNextStepUrl(this.currentStepUrl)
        this.$router.push({
          name: this.$options.name,
          params: { stepName: nextStepUrl },
        })
      }
    },
    previousStep(): void {
      const nextStepUrl = ValuationService.getNextStepUrl(
        this.currentStepUrl,
        true
      )
      this.$router.push({
        name: this.$options.name,
        params: { stepName: nextStepUrl },
      })
    },
    resetValuationData(): void {
      this.$store.dispatch('valuationProcess/resetValuationData')
      this.$router.push({
        name: 'valuation',
        params: { stepName: 'property' },
      })
    },
    submitValuation() {
      const errorMessages: Message[] = []
      for (const valuationStep of this.valuation.steps) {
        const messages = valuationStep.validator
          .validate(valuationStep.data)
          .filter(m => m.type === MessageType.Error)
        errorMessages.push(...messages)
      }

      if (errorMessages.length) {
        this.$store.dispatch('app/addTempMessages', { messages: errorMessages })
      } else {
        this.$store.dispatch('valuationProcess/submitValuation')
      }
    },
  },
  watch: {
    currentStepUrl(stepName: string) {
      this.goToStep(stepName)
    },
  },
})
